import React from "react";
import "./projectComponent.css";
import OptimizedSlideshow from './OptimizedSlideshow';
import yopex1 from "./images/yopex1.png";
import yopex2 from "./images/yopex2.png";
import yopex3 from "./images/yopex3.png";
import yopex4 from "./images/yopex4.png";
import yopex5 from "./images/yopex5.png";
import yopex6 from "./images/yopex6.png";
import yopex7 from "./images/yopex7.png";
import yopex8 from "./images/yopex8.png";
import yopex9 from "./images/yopex9.png";
import yopex10 from "./images/yopex10.png";
import yopex11 from "./images/yopex11.png";


const Yopex = () => {
    const mediaItems = [
        {
            type: 'image',
            src: yopex1,
        },
        {
            type: 'image',
            src: yopex2,
        },
        {
            type: 'image',
            src: yopex3,
        },
        {
            type: 'image',
            src: yopex4,
        },
        {
            type: 'image',
            src: yopex5,
        },
        {
            type: 'image',
            src: yopex6,
        },
        {
            type: 'image',
            src: yopex7,
        },
        {
            type: 'image',
            src: yopex8,
        },
        {
            type: 'image',
            src: yopex9,
        },
        {
            type: 'image',
            src: yopex10,
        },
        {
            type: 'image',
            src: yopex11,
        }
    ];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">Yopex</h2>
        <span className="section__subtitle">
            My side project!
            <a href="https://www.linkedin.com/company/yopex" target="_blank" rel="noopener noreferrer" style={{marginLeft: '10px', color: '#0077b5', fontSize: '1.2em'}}>
                <i className="uil uil-linkedin"></i>
            </a>
        </span>
        <OptimizedSlideshow mediaItems={mediaItems} />
        
        <div className="about__container container grid">
            <div className="text__container">
                <h3 className="title">Description:</h3>
                <br />
                <p className='redRadio__text'>
                    Yopex is an AI-powered platform that revolutionizes job searching for both seekers and recruiters. 
                    Born from personal experience watching a talented family member struggle for 4 years to land a job despite an amazing career.
                </p>
                <br />
                
                <h4 className="title" style={{fontSize: '1.1rem', marginBottom: '0.5rem'}}>For Job Seekers</h4>
                <ul style={{listStyle: 'none', padding: '0', margin: '0'}}>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>🔍 Smart Job Discovery</strong> - AI-powered job search and scraping based on CV analysis
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>📄 ATS-Optimized CV Builder</strong> - Generate professional, recruiter-friendly resumes
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>✨ Tailored Applications</strong> - Customize CVs, emails, and cover letters for each role
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>🎯 AI Interview Coach</strong> - Personal and technical interview preparation with intelligent feedback
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>🚀 Mass Application System</strong> - Automated applications with 57% higher success rate
                    </li>
                </ul>
                <br />
                
                <h4 className="title" style={{fontSize: '1.1rem', marginBottom: '0.5rem'}}>For Recruiters</h4>
                <p className='redRadio__text'>
                    Streamlined job posting platform with intelligent candidate matching and management tools.
                </p>
            </div>

            <div className="skills__container1 container grid">
        <div className="skills__content">
        <h3 className="skills__title">Technologies Used</h3>

        <div className="skills__box">

        <div className="skills__group">

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Django</h3>
                <span className="skills__level">Backend</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Agents</h3>
                <span className="skills__level">AI</span>
            </div>
            </div>

            

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Docker</h3>
                <span className="skills__level">Deployment</span>
            </div>
            </div>
        </div>

        <div className="skills__group">
            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">NextJS</h3>
                <span className="skills__level">Frontend</span>
              </div>
            </div>

            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">ML/DL</h3>
                <span className="skills__level">Prediction</span>
              </div>
            </div>
            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Figma</h3>
                <span className="skills__level">UI/UX</span>
            </div>
            </div>
          
          
        </div>

        </div>
    </div>
            </div>
        </div>
    </section>
    );
};

export default Yopex;